export const isRecurrentPricesInProduct = (product) => {
  const { price_monthly, price_quartally, price_semiannually, price_annually } =
    product;
  return (
    price_monthly || price_quartally || price_semiannually || price_annually
  );
};
